<div class="row mb-4">
    <div class="col-md-3">
        <label for="input">Mobile No*</label>
        <div class="w-100">
            <p-autoComplete
                [(ngModel)]="searchPhone"
                [suggestions]="filteredClients"
                (completeMethod)="searchClients($event)"
                (onSelect)="onClientSelect($event)"
                [disabled]="disableSearchPhone"
                placeholder="Search by phone or name"
                [minLength]="3"
                [showEmptyMessage]="false"
                [delay]="400"
                field="mobile_number"
                styleClass="w-100"
                style="width: 100%;"
                inputStyleClass="w-100"
                [dropdown]="false"
                [forceSelection]="false"
                dataKey="patient_id"
            >
                <ng-template let-client pTemplate="item">
                    <div class="p-2" [ngClass]="{'bg-light': client.isNewNumber}">
                        <div class="font-medium text-sm" [ngClass]="{'text-primary': client.isNewNumber}">
                            {{ client.patient_name }}
                        </div>
                        <div class="text-xs text-gray-500">{{ client.mobile_number }}</div>
                    </div>
                </ng-template>
            </p-autoComplete>
        </div>
        <!-- <span class="p-input-icon-left d-block">
            <i class="pi pi-search"></i>
            <input id="input" type="text" placeholder="Search" pInputText [(ngModel)]="searchPhone" (ngModelChange)="searchWithPhoneNumber()" (keydown)="validatePhoneNumber($event)" maxlength="10" #searchPhoneInput [disabled]="disableSearchPhone" />
        </span> -->
    </div>
    <div *ngIf="disableSearchPhone"  class="col-md-1 pt-4">
        <button type="button" pButton class="btn btn-primary" (click)="clearPhoneSearch()">Clear</button>
    </div>
    <ng-container *ngIf="disableSearchPhone">
        <div class="col-md-3">
            <label for="input">New Mobile No*</label>
            <input id="input" type="text" placeholder="Enter new number" pInputText [(ngModel)]="newMobileNumber" (keydown)="validatePhoneNumber($event)" maxlength="10" />
        </div>
        <div class="col-md-1 pt-4">
            <button type="button" pButton class="btn btn-primary" (click)="updatePhoneSearch()" [disabled]="newMobileNumber?.toString().length < 10">Update</button>
        </div>
    </ng-container>
</div>

<h4 class="mb-3">Demographic Details</h4>

<ng-container [formGroup]="registrationForm">

    <div class="row mb-4">
        <div class="col-md-4 mb-4">
            <label for="dropdown">Corporate Social Responsibility (CSR)*</label>
            <p-dropdown id="dropdown" [readonly]="isRegularCsrSelected" [options]="csrListOptions" [disabled]="isRegularCsrSelected" formControlName="csr_id" [filter]="true"
                [autoDisplayFirst]="false" [ngClass]="{'csr-disabled': isRegularCsrSelected}" placeholder="Select csr"></p-dropdown>
            <div class="invalid-feedback" *ngIf=" submit && registrationForm.get('csr_id').errors?.required">
                CSR is required
            </div>
        </div>

        <div class="col-md-4 mb-4" *ngIf="isRegularCsrSelected">
            <label for="" class="form-label">Is CSR Revoked?</label>
            <div class="radio-group">
                <div class="p-field-radiobutton">
                    <p-radioButton inputId="revokeCsrYes" name="is_csr_revoked" [value]="true"
                        formControlName="is_csr_revoked">
                    </p-radioButton>
                    <label for="revokeCsrYes" class="p-radiobutton-label cursor-pointer">Yes</label>
                </div>
                <div class="p-field-radiobutton">
                    <p-radioButton inputId="revokeCsrNo" name="is_csr_revoked" [value]="false"
                        formControlName="is_csr_revoked">
                    </p-radioButton>
                    <label for="revokeCsrNo" class="p-radiobutton-label cursor-pointer">No</label>
                </div>

            </div>
        </div>

        <div class="col-md-4 mb-4">
            <label for="dropdown">Lead Source*</label>
            <p-dropdown id="dropdown" [options]="leadSourceOptions" formControlName="leadSourceId" filter="true"
                placeholder="Select Lead Source" (onChange)="setLeadSorceName()"
                ></p-dropdown>
            <!-- Validation error message -->
            <div class="invalid-feedback" *ngIf=" submit && registrationForm.get('leadSourceId').errors?.required">
                Lead Source is required
            </div>
        </div>
        
        <div class="col-md-4 mb-4">
            <label for="dropdown">Country*</label>
            <p-dropdown id="dropdown" [options]="countryOptions" formControlName="countryId" filter="true"
                placeholder="Select Country" (onChange)="setCountryName()">
            </p-dropdown>
            <!-- Validation error message -->
            <div class="invalid-feedback" *ngIf=" submit && registrationForm.get('countryId').errors?.required">
                Country is required
            </div>
        </div>
        <div class="col-md-4 mb-4">
            <label for="email">Email ID*</label>
            <input id="email" type="email" pInputText formControlName="email" placeholder="Enter Email ID" [ngClass]="{'is-invalid': submit && registrationForm.get('email').invalid}" />
            <!-- Validation error messages -->
            <div *ngIf="submit && registrationForm.get('email').errors" class="invalid-feedback">
                <div *ngIf="registrationForm.get('email').errors.required">Email ID is required</div>
                <div *ngIf="registrationForm.get('email').errors.email">Invalid email format</div>
            </div>
        </div>
        <div class="col-md-4 mb-4">
            <label for="phoneNumber">Mobile No*</label>
            <input id="phoneNumber" type="tel" pInputText formControlName="phoneNumber" placeholder="Enter Mobile No." [ngClass]="{'is-invalid': submit && registrationForm.get('phoneNumber').invalid}" (keydown)="validatePhoneNumber($event)" maxlength="10" />
            <!-- Validation error messages -->
            <div *ngIf="submit && registrationForm.get('phoneNumber').errors" class="invalid-feedback">
                <div *ngIf="registrationForm.get('phoneNumber').errors.required">Mobile no. is required</div>
                <div *ngIf="registrationForm.get('phoneNumber').errors.pattern">Phone number must be numeric</div>
                <div *ngIf="registrationForm.get('phoneNumber').errors.maxlength">Phone number cannot exceed 10 digits
                </div>
                <div *ngIf="registrationForm.get('patientName')?.errors?.['leadingSpace']"></div>
                <div *ngIf="registrationForm.get('patientName')?.errors?.['multipleSpaces']"></div>
            </div>
        </div>
        <div class="col-md-4 mb-4">
            <div class="d-flex gap-2">
                <div class="w-20" formGroupName="rppRegistrationForm" *ngIf="selectedService === 'RPP'">
                    <label for="input">Patient Title*</label>
                    <p-dropdown id="dropdown" optionLabel="field_value" optionValue='field_value' [options]="userTitle" formControlName="patient_title"
                        placeholder="Select Title">
                    </p-dropdown>
                     <div class="invalid-feedback" *ngIf="submit && registrationForm?.get('rppRegistrationForm.patient_title').errors?.required">
                        Title is required
                    </div>
                </div>
                <div class="w-100">
                    <label for="input">Patient Name*</label>
                    <input id="input" type="text" pInputText formControlName="patientName" placeholder="Enter Patient Name" />
                    <!-- Validation error message -->
                    <div class="invalid-feedback" *ngIf="submit && registrationForm.get('patientName').errors?.required">
                        Patient Name is required
                    </div>
                    <div class="invalid-feedback" *ngIf="submit && registrationForm.get('patientName').errors?.pattern">
                        Patient Name should contain alphabets only
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 mb-4" formGroupName="rppRegistrationForm" *ngIf="selectedService === 'RPP'">
            <div class="d-flex gap-2">
                <div class="w-20">
                    <label for="input">Father Title</label>
                    <p-dropdown id="dropdown" optionLabel="field_value" optionValue='field_value' [options]="userTitle" formControlName="father_title"
                        placeholder="Select Title">
                    </p-dropdown>
                     <!-- <div class="invalid-feedback" *ngIf="submit && registrationForm?.get('rppRegistrationForm.father_title').errors?.required">
                        Title is required
                    </div> -->
                </div>
                <div class="w-100">
                    <label for="input">Father/Spouse Name</label>
                    <input id="input" type="text" pInputText formControlName="father_spouse_name" placeholder="Enter Father/Spouse Name" />
                    <!-- Validation error message -->
                    <!-- <div class="invalid-feedback" *ngIf="submit && registrationForm?.get('rppRegistrationForm.father_spouse_name').errors?.required">
                        Patient Name is required
                    </div> -->
                    <!-- <div class="invalid-feedback" *ngIf="submit && registrationForm?.get('rppRegistrationForm.father_spouse_name').errors?.pattern">
                        Patient Name should contain alphabets only
                    </div> -->
                </div>
            </div>
        </div>
        <div class="col-md-4 mb-4">
            <label for="calendar">Date of Birth*</label>
            <p-calendar #dobCalendar id="calendar" formControlName="dob" class="full-width"
                placeholder="MM/DD/YYYY" [maxDate]="maxDate" [monthNavigator]="true" [yearNavigator]="true"
                [yearRange]="'1924:' + currentYear" [defaultDate]="maxDate" [appendTo]="'body'" (onInput)="onDobEnterValue($event)">
            </p-calendar>
            <!-- Validation error message -->
            <div class="invalid-feedback" *ngIf=" submit && registrationForm.get('dob').errors?.required">
                DOB (Date of birth) is required
            </div>
        </div>
        <div class="col-md-4">
            <label for="dropdown">Gender*</label>
            <p-dropdown id="dropdown" [options]="genderOptions" formControlName="genderId" filter="true"
                placeholder="Select a Gender" (onChange)="setGenderName()">
            </p-dropdown>
            <!-- Validation error message -->
            <div class="invalid-feedback" *ngIf=" submit && registrationForm.get('genderId').errors?.required">
                Gender is required
            </div>
        </div>
        <div class="col-md-4" formGroupName="rppRegistrationForm" *ngIf="selectedService === 'RPP'">
            <label for="input">Select Marital</label>
            <p-dropdown [options]="maritalList" formControlName='marital_status_type' optionLabel="field_value"
                        optionValue='field_code' placeholder="Select Marital">
            </p-dropdown>
            <!-- <div class="invalid-feedback" *ngIf="submit && registrationForm?.get('rppRegistrationForm.marital_status_type').errors?.required">
                Marital Status is required
            </div> -->
        </div>
        <div class="col-md-4" formGroupName="rppRegistrationForm" *ngIf="selectedService === 'RPP'">
            <label for="input">Select Education</label>
            <p-dropdown [options]="educationList" formControlName='edu_type' optionLabel="field_value"
                        optionValue='field_code' placeholder="Select Education">
            </p-dropdown>
            <!-- <div class="invalid-feedback" *ngIf="submit && registrationForm?.get('rppRegistrationForm.edu_type').errors?.required">
               Education is required
            </div> -->
        </div>
        <div class="col-md-4" formGroupName="rppRegistrationForm" *ngIf="selectedService === 'RPP'">
            <div class="d-flex gap-2">

                <!-- Occupation -->
                <div [class]="registrationForm.get('rppRegistrationForm.occupation_code')?.value == 1095 ? 'w-50' : 'w-100'">
                <label for="occupation">Select Occupation</label>
                <p-dropdown id="occupation"
                            [options]="occupationlist"
                            formControlName="occupation_code"
                            optionLabel="field_value"
                            optionValue="field_code"
                            placeholder="Select Occupation">
                            <!-- (onChange)="makeOthersFieldMandatory('rppRegistrationForm.occupation_code', 'rppRegistrationForm.other_occupation', 1095)" -->
                </p-dropdown>
                <!-- <div class="invalid-feedback"
                    *ngIf="submit && registrationForm.get('rppRegistrationForm.occupation_code')?.errors?.['required']">
                    Occupation is required
                </div> -->
                </div>

                <!-- Other Occupation -->
                <div [class]="registrationForm.get('rppRegistrationForm.occupation_code')?.value == 1095 ? 'w-50' : ''"
                    *ngIf="registrationForm.get('rppRegistrationForm.occupation_code')?.value == 1095">
                <label for="otherOccupation">Other Occupation</label>
                <input id="otherOccupation" type="text" pInputText formControlName="other_occupation"
                        placeholder="Enter Other Occupation" />
                <!-- <div class="invalid-feedback"
                    *ngIf="submit && registrationForm.get('rppRegistrationForm.other_occupation')?.errors?.['required']">
                    Other Occupation is required
                </div> -->
                </div>

            </div>
            </div>


            <div class="col-md-4" formGroupName="rppRegistrationForm" *ngIf="selectedService === 'RPP'">
                  <div class="d-flex gap-2">
                    <div [class]="photo_id_type ? 'w-50' : 'w-100'">
                         <label for="Patient">Photo Id Type</label>
                        <p-dropdown [options]="patientID" formControlName='photo_id_type' optionLabel="field_value"
                                optionValue='field_code'(onChange)="getPhotoId($event)"  placeholder="Select Id Type" >
                        </p-dropdown>
                    </div>
                    <div [class]="photo_id_type ? 'w-50' : ''">
                        <div *ngIf="photo_id_type == '2'">
                                <label for="adhar">Aadhar Number</label>
                                <input type="text" id="adhar" placeholder="Enter Aadhar Number" (input)="sanitizeNumberInput($event)" pInputText formControlName="aadhar" maxlength="12" 
                                       inputmode="numeric" pattern="[0-9]*"
                                       >
                        </div>
                        <div *ngIf="photo_id_type=='1'">
                                <label for="Passport">Passport</label>
                                <input type="text" id="Passport" pInputText placeholder="Enter Passport Id Number" formControlName='passport' maxlength="12">
                            <div class="invalid-feedback">
                                <div class="invalid-feedback" *ngIf="registrationForm?.get('rppRegistrationForm.passport').errors?.pattern">
                                    Passport number must contain only numbers.
                                </div>
                            </div>
                        </div>
                        <div *ngIf="photo_id_type=='3'">
                                <label for="voterid">Voter ID</label>
                                <input type="text" id="voterid" pInputText placeholder="Enter Voter Id Number" formControlName='voter_id'>
                        </div>
                        <div *ngIf="photo_id_type=='4'">
                            <label for="driving">Driving Licence</label>
                                <input type="text" id="driving" pInputText placeholder="Enter Driving Licence Number" formControlName='driving'>
                            <div class="invalid-feedback" *ngIf="submit && registrationForm?.get(['rppRegistrationForm.driving']).hasError('pattern')"
                               placement="bottom">
                                Driving Licence is Invalid
                            </div>
                        </div>

                    </div>
                  </div>
               </div>

    </div>

    <h4 class="mb-4">Address Details</h4>

    <div class="form-check mb-3 ps-0">
        <input #addressCheckbox type="checkbox" id="sameAddress" (change)="copyCurrentAddress($event)" class="form-check-input"
            [disabled]="!permanantAddressAutoFill" />
        <label for="sameAddress" class="form-check-label">Permanent Address Same as Current Address</label>
    </div>

    <div class="row mb-4">
        <div class="col-md-4">
            <label for="input">Current Address*</label>
            <input id="input" type="text" pInputText formControlName="currentAddress"
                placeholder="Enter Current Address" />
            <!-- Validation error message -->
            <div class="invalid-feedback" *ngIf=" submit && registrationForm.get('currentAddress').errors?.required">
                Current Address is required
            </div>
            <div class="invalid-feedback" *ngIf="submit && registrationForm.get('currentAddress').errors?.pattern">
                Please enter a valid address. Avoid starting/ending with spaces or using special characters other than , . / -
            </div>
        </div>
        <div class="col-md-4">
            <label for="dropdown">Current State/UT*</label>
            <p-dropdown id="dropdown" [options]="stateCurrentOptions" filter="true"
                (onChange)="getDistrictOptions($event.value, 'current');setCurrentStateName()"
                formControlName="currentStateId" placeholder="Select Current State">
            </p-dropdown>
            <!-- Validation error message -->
            <div class="invalid-feedback" *ngIf=" submit && registrationForm.get('currentStateId').errors?.required">
                Current State/UT is required
            </div>
        </div>
        <div class="col-md-4">
            <label for="dropdown">Current District</label>
            <p-dropdown id="dropdown" [options]="districtCurrentOptions" filter="true"
                formControlName="currentDistrictId" placeholder="Select Current District"
                (onChange)="setCurrentDistrictName()">
            </p-dropdown>
        </div>
    </div>

    <div class="row mb-4">
        <div class="col-md-4">
            <label for="input">Permanent Address*</label>
            <input id="input" type="text" pInputText formControlName="permanentAddress"
                placeholder="Enter Permanent Address" (blur)="setPermanentAddressUpdateType(AddressUpdateType.Update)" />
            <!-- Validation error message -->
            <div class="invalid-feedback" *ngIf=" submit && registrationForm.get('permanentAddress').errors?.required">
                Permanent Address is required
            </div>
            <div class="invalid-feedback" *ngIf="submit && registrationForm.get('permanentAddress').errors?.pattern">
                Please enter a valid address. Avoid starting/ending with spaces or using special characters other than , . / -
            </div>
        </div>
        <div class="col-md-4">
            <label for="dropdown">Permanent State/UT*</label>
            <p-dropdown id="dropdown" [options]="statePermanentOptions" filter="true"
                (onChange)="getDistrictOptions($event.value, 'permanent');setPermanentStateName();setPermanentAddressUpdateType(AddressUpdateType.Update)"
                formControlName="permanentStateId" placeholder="Select Permanent State">
            </p-dropdown>
            <!-- Validation error message -->
            <div class="invalid-feedback" *ngIf=" submit && registrationForm.get('permanentStateId').errors?.required">
                Permanent State/UT is required
            </div>
        </div>
        <div class="col-md-4">
            <label for="dropdown">Permanent District</label>
            <p-dropdown id="dropdown" [options]="districtPermanentOptions" filter="true"
                formControlName="permanentDistrictId" placeholder="Select Permanent District"
                (onChange)="setPermanentDistrictName();setPermanentAddressUpdateType(AddressUpdateType.Update)">
            </p-dropdown>
        </div>
    </div>

    <div class="row mb-4">
        <div class="col-md-4">
            <label for="dropdown">Marketing Person*</label>
            <p-dropdown id="dropdown" 
                        [options]="marketingUserOptions"
                        formControlName="marketing_person_id"
                        [filter]="true" 
                        (onChange)="onMarketingPersonChange($event)"  
                        [autoDisplayFirst]="false" 
                        placeholder="Select Marketing Person Name">
            </p-dropdown>
            <div class="invalid-feedback"
                *ngIf=" submit && registrationForm.get('marketing_person_id').errors?.required">
                Marketing Person is required
            </div>
        </div>
        <div class="col-md-4">
            <label for="" class="form-label">Availing NVF Support?*</label>
            <div class="radio-group">
                <div class="p-field-radiobutton">
                    <p-radioButton inputId="nvfYes" name="isNvfFacility" [value]="true" formControlName="isNvfFacility">
                    </p-radioButton>
                    <label for="nvfYes" class="p-radiobutton-label">Yes</label>
                </div>
                <div class="p-field-radiobutton">
                    <p-radioButton inputId="nvfNo" name="isNvfFacility" [value]="false" formControlName="isNvfFacility"
                        (click)="registrationForm.get('isNvfFacility').enabled && resetNvfItems(); setDisableNvfRevokeDate(true)">
                    </p-radioButton>
                    <label for="nvfNo" class="p-radiobutton-label">No</label>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <label for="" class="form-label">Select NVF items</label>
            <div class="p-field-radiobutton d-flex">
                <fieldset [disabled]=" !registrationForm.get('isNvfFacility').value ">
                    <div class="field-checkbox">
                        <input type="checkbox" id="nvfOpd" name="isNvfOpd" [value]="true" formControlName="isNvfOpd"
                            class="form-check-input" />
                        <label for="nvfOpd" class="form-check-label">OPD</label>
                    </div>
                </fieldset>

                <fieldset [disabled]=" !registrationForm.get('isNvfFacility').value ">
                    <div class="field-checkbox">
                        <input type="checkbox" id="nvfRpp" name="isNvfRpp" [value]="true" formControlName="isNvfRpp"
                            class="form-check-input" />
                        <label for="nvfRpp" class="form-check-label">RPP</label>
                    </div>
                </fieldset>

                <fieldset [disabled]=" !registrationForm.get('isNvfFacility').value ">
                    <div class="field-checkbox">
                        <input type="checkbox" id="nvfAssessment" name="isNvfAssessment" [value]="true"
                            formControlName="isNvfAssessment" class="form-check-input" />
                        <label for="nvfAssessment" class="form-check-label">Assessment</label>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>

    <div *ngIf="patientDetailsData?.is_nvf_facility" class="row">
        <div class="col-4">
            <label for="" class="form-label">Revoke NVF Support?</label>
            <div class="radio-group">
                <div class="p-field-radiobutton">
                    <p-radioButton inputId="revokeNvfYes" name="isNvfSupportRevoked" [value]="true"
                        formControlName="isNvfSupportRevoked" [disabled]="!registrationForm.get('isNvfFacility').value"
                        (click)="registrationForm.get('isNvfFacility').value && setDisableNvfRevokeDate(false)">
                    </p-radioButton>
                    <label for="revokeNvfYes" class="p-radiobutton-label">Yes</label>
                </div>
                <div class="p-field-radiobutton">
                    <p-radioButton inputId="revokeNvfNo" name="isNvfSupportRevoked" [value]="false"
                        formControlName="isNvfSupportRevoked" [disabled]="!registrationForm.get('isNvfFacility').value"
                        (click)="registrationForm.get('isNvfFacility').value && setDisableNvfRevokeDate(true)">
                    </p-radioButton>
                    <label for="revokeNvfNo" class="p-radiobutton-label">No</label>
                </div>

            </div>
        </div>
        <div class="col-3">
            <label for="" class="form-label">NVF Revocation From*</label>
            <p-calendar id="dob" formControlName="nvfRevokeDate" [showIcon]="true"
                placeholder="Select NVF revocation date" [disabled]="disableNvfRevokeDate" [appendTo]="'body'">
            </p-calendar>
        </div>
    </div>
</ng-container>

<p-toast key="leadSourceWarning"></p-toast>